module.exports = __webpack_public_path__ + "media/assets/plane-10-color-26f77c729c4625908e5261419d18a23f.svg";